import { Checkbox } from "antd";
import styled from "styled-components";

import { theme } from "theme/theme";

export const WrapperSection = styled.div`
  position: relative;
  border: 1px solid ${theme.colors.border};
  border-radius: 8px;
  padding: 23px 15px;
  width: 100%;
  max-width: 100%;

  .hidden {
    display: none;
  }

  ${theme.media.mobileXL} {
    padding: 23px 23px 23px;
  }
  @media screen and (min-width: 768px) {
    padding: 39px 23px 23px;
  }
`;

export const WrapperSection2 = styled(WrapperSection)`
  max-width: fit-content;
`;

export const WrapperTitle = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: -16px;
  left: 9px;
  background: ${theme.colors.white};
  padding: 0 8px;
`;

export const RequestFormLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  .label {
    font-weight: ${theme.fontWeight.bold};
    font-size: ${theme.sizes.lg};
    line-height: 26px;
    color: ${theme.colors.titleText};
  }
`;

export const WrapperCheckbox = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const LastCheckboxStyled = styled(Checkbox)`
  align-items: center;
  outline: none;
  margin-left: 0px !important;
  margin-bottom: 0px;
  &:hover {
    .ant-checkbox-inner {
      border-color: ${theme.colors.border};
    }
  }
  .ant-checkbox {
    top: unset;
  }
  .ant-checkbox-inner {
    width: 20px;
    height: 21px;
    border: 2px solid ${theme.colors.border};
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${theme.colors.button};
    border-color: ${theme.colors.button}!important;
  }
  .ant-checkbox-checked::after {
    border: none;
  }
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${theme.colors.border};
  }
  .ant-checkbox + span {
    padding-right: 0;
  }
  div {
    font-size: ${theme.sizes.md};
    font-weight: ${theme.fontWeight.bold};
    line-height: 16px;
  }
`;

export const WrapperInforIcon = styled.div`
  position: relative;
  cursor: pointer;
  padding-top: 3px;

  &:hover {
    .wrapper-tooltip {
      display: block;
    }
  }
`;

export const RequestCheckItem = styled.li`
  font-weight: ${theme.fontWeight.regular};
  font-size: ${theme.sizes.sm};
  line-height: 20px;
  list-style: none;
  color: #3b3b3b;
  margin-top: 2px;
`;

export const WrapperMethod = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .title {
    font-family: Noto Sans JP;
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #3b3b3b;
  }
`;

export const AudioWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 20px;
  flex-direction: column;
  .ant-radio-wrapper {
    height: max-content;
    align-items: center;
    display: flex;
  }
  .ant-radio-wrapper::after {
    display: none;
  }
  .ant-radio-wrapper > span:not(.ant-radio) {
    font-size: 18px;
    line-height: 18px;
    padding-left: 6px;
    padding-right: 0;
  }
  .ant-radio {
    top: 0;
  }
  .ant-radio-inner {
    border: 2px solid #cccccc;
    width: 20px;
    height: 20px;
  }
  .ant-radio-checked .ant-radio-inner {
    border: 2px solid #cccccc;
    width: 20px;
    height: 20px;
  }
  .ant-radio-inner::after {
    background-color: #2ac769;
    top: calc(50% - 6px);
    left: calc(50% - 6px);
    width: 12px;
    height: 12px;
  }
  .ant-radio:hover .ant-radio-inner,
  .ant-radio:hover .ant-radio-checked .ant-radio-inner {
    border-color: #cccccc;
  }

  ${theme.media.tablet} {
    gap: 18px;
    flex-direction: row;
  }
`;

export const CheckBoxLabel = styled(RequestCheckItem)`
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
`;

export const WrapperUniqueLabel = styled.div`
  .title {
    font-family: Noto Sans JP;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #3b3b3b;
    margin-bottom: 18px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 22px;
  margin-bottom: 32px;
  flex-direction: column;

  @media screen and (min-width: 635px) {
    flex-direction: row;
  }

  ${theme.media.tabletL} {
    align-items: center;
  }
`;

export const WrapperOption = styled.div`
  .title {
    font-family: Noto Sans JP;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #3b3b3b;
    margin-bottom: 18px;
  }

  span {
    font-family: Noto Sans JP;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #3b3b3b;
  }
`;

export const CheckboxStyled = styled(Checkbox)(({ theme }) => ({
  alignItems: "unset",
  outline: "none",
  "&:hover": {
    ".ant-checkbox-inner": {
      borderColor: theme.colors.border,
    },
  },
  ".ant-checkbox": {
    top: "unset",
  },
  ".ant-checkbox-inner": {
    width: 20,
    height: 21,
    border: `2px solid ${theme.colors.border}`,
  },
  ".ant-checkbox-checked .ant-checkbox-inner": {
    backgroundColor: theme.colors.button,
    borderColor: `${theme.colors.button}!important`,
  },
  ".ant-checkbox-checked::after": {
    border: "none",
  },
  ".ant-checkbox-input:focus + .ant-checkbox-inner": {
    borderColor: theme.colors.border,
  },
}));

export const WrapperGroupCheckbox = styled.div`
  display: flex;
  // flex-direction: column;
  align-items: center;
  gap: 16px;
  position: relative;

  .ant-checkbox-wrapper {
    margin-left: 0;
    align-items: center;
  }
`;

export const WrapperPrivateCheckbox = styled.div`
  input {
    margin-left: 29px;
  }
`;

export const WrapperPrivateCheckbox2 = styled(WrapperPrivateCheckbox)`
  position: absolute;
  right: -194px;

  .label {
    margin-left: 29px;
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #3b3b3b;
    margin-bottom: 8px;
  }
`;

export const WrapperGroupRadio = styled.div`
  display: flex;
  // flex-direction: column;
  align-items: center;
  gap: 4px;

  .ant-radio-wrapper {
    margin-right: 0;
  }

  .ant-radio-wrapper span.ant-radio + * {
    font-size: 18px;
    line-height: 18px;
  }

  .ant-radio-inner {
    border: 2px solid #cccccc;
    width: 20px;
    height: 20px;
  }
`;

export const WrapperLink = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 16px;
  /* height: 71px; */
  width: 100%;
  border-radius: 8px;
  background: #f2f2f2;
  padding: 17px 16px;

  .link {
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    cursor: pointer;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;

    span {
      color: #1a2f62;
    }
  }

  .function {
    color: #2f8cae;
    font-family: Noto Sans JP;
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    cursor: pointer;
    min-width: fit-content;

    > div {
      display: flex;
      align-items: center;
    }

    > div:first-child {
      margin-left: 4px;
      margin-bottom: 5px;
    }
  }

  .copy,
  .download {
    transition: all 0.5s ease-out;
  }

  @media screen and (min-width: 635px) {
    width: calc(100% - 232px);
  }

  ${theme.media.tabletL} {
    align-items: center;
    flex-direction: row;
    height: 71px;
  }
`;

export const RadioStyled = styled.div`
  .ant-radio {
    top: 4px;
  }
  .ant-radio-wrapper:hover .ant-radio,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner {
    border-color: #cccccc;
  }
  .ant-radio-checked .ant-radio-inner {
    border-color: #cccccc;
  }
  .ant-radio-inner {
    width: 24px;
    height: 24px;
    border-width: 2px;
  }
  .ant-radio-inner::after {
    width: 14px;
    height: 14px;
    // margin-top: -1px;
    // margin-left: -1px;
    background-color: #2ac769;
  }
`;

export const CheckboxStyledExpand = styled(CheckboxStyled)(({ theme }) => ({
  ".ant-checkbox-inner": {
    width: 14,
    height: 14,
  },
  ".ant-checkbox-inner::after": {
    top: "40%",
    left: "14.5%",
  },
}));

export const WrapperTooltip = styled.div`
  position: absolute;
  background: #fff;
  border: 1px solid ${theme.colors.border};
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.16);
  border-radius: 6px;
  left: 25px;
  top: -17px;
  padding: 8px 0 8px 8px;
  z-index: 99;
  font-size: 12px;
  line-height: 12px;
  font-weight: 700;
  color: #fb4e4e;

  &::after {
    content: "";
    position: absolute;
    top: 25px;
    left: -5px;
    height: 7px;
    width: 7px;
    background: ${theme.colors.border};
    transform: rotate(45deg);
  }
  &::before {
    content: "";
    position: absolute;
    top: 22px;
    left: -2px;
    width: 6px;
    height: 10px;
    background: ${theme.colors.white};
    transform: rotate(45deg);
    z-index: 1;
  }

  > div {
    min-width: 266px;
    width: 266px;
    height: 370px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 16px;
    }
    &::-webkit-scrollbar-track {
      margin: 5px 0px 5px;
      border-left: 4px solid ${theme.colors.white};
      border-right: 4px solid ${theme.colors.white};
      background: ${theme.colors.background};
      border-radius: 7px;
    }
    &::-webkit-scrollbar-thumb {
      background: #bdbdbd;
      border-radius: 7px;
      border-left: 4px solid ${theme.colors.white};
      border-right: 4px solid ${theme.colors.white};
    }
  }

  img {
    width: 100%;
  }
`;
